import axios from 'axios';
import getUrl from 'utils/getUrl';
import {
  mapCaptchaVerifyResponse,
  mapCaptchaVerifyToApiModel,
} from './dataMapper/takerDataMapper';

export default token =>
  axios
    .post(
      getUrl.api('/recaptcha/verify'),
      mapCaptchaVerifyToApiModel({ token }),
    )
    .then(({ data }) => mapCaptchaVerifyResponse(data));
